/**
 * cn, the class-name joiner: clsx to drop the falsy and flatten, then
 * tailwind-merge so a later class wins over a conflicting earlier one
 * ('p-2' then 'p-4' leaves 'p-4').
 *
 * A leftover twin of src/lib/utils.ts, the one shadcn generates against and
 * the rest of the app imports ('@/lib/utils'). Only form, input, label,
 * switch and toast under shared/components/ui still import this copy. The
 * two behave the same; new code should use '@/lib/utils'.
 *
 * @module shared/utils
 */

import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Joins class names, Tailwind conflicts resolved in favour of the last.
 *
 * @param inputs - Strings, arrays, objects of class: condition, and falsy values to skip.
 * @returns One class string.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
} 